import { render } from "./district_master.vue?vue&type=template&id=0998b9ea&scoped=true"
import script from "./district_master.vue?vue&type=script&lang=js"
export * from "./district_master.vue?vue&type=script&lang=js"

import "./district_master.vue?vue&type=style&index=0&id=0998b9ea&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MSRTC\\MSRTC-CODE\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0998b9ea"]])

export default __exports__